
import { useEffect, useState } from "react";
import LeftPanelComponent from "../../DetailPage/DetailPageLeftPanel/LeftPanelComponent";
import RightPanelComponent from "../../DetailPage/DetailPageRightPanel/RightPanelComponent";
import DetailPageDescComponent from "../../Misc/DetailPageDesc/DetailPageDescComponent";
import DetailPageTitleComponent from "../../Misc/DetailPageTitle/DetailPageTitleComponent";
import TitleLogoComponent from "../../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../../Misc/TitleTags/TitleTagsComponent";
import "./VideoDetailComponent.scss"
import { convertTimeFormat } from "../../../../utils/AppUtils";
import { useTranslation } from "react-i18next";

const VideoDetailComponent = ({ videoData, isMobile }) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(true)
    const [videoId, setVideoId] = useState('')
    const [videoCode, setVideoCode] = useState('')
    const [tagsArray, setTagsArray] = useState('')

    useEffect(() => {
        if (videoData.product_name) {
            setIsLoading(false)
            setVideoId(videoData?.product_id ? videoData?.product_id : '-')
            setVideoCode(videoData?.course_code ? videoData.course_code : '-')
            let tags = []
            if (videoData.provider?.provider_display_name) tags.push(videoData.provider?.provider_display_name)
            tags.push('Video')
            if (videoData.views) tags.push(`${videoData.views} View${videoData.views > 1 ? 's' : ''}`)
            if (videoData.course_duration) tags.push(convertTimeFormat(videoData.course_duration, true, t))
            setTagsArray(tags)
        } else {
            setIsLoading(true)
        }
    }, [videoData])
    return (
        <>
            <div className="row video-detail">
                <div className="col-md-8 col-sm-12">
                    <LeftPanelComponent 
                        id={videoId}
                        code={videoCode}
                        title={videoData?.product_name ? videoData?.product_name : '-'}
                        logoURL={videoData?.provider?.provider_img ? videoData?.provider?.provider_img : ""}
                        tagsArray={isLoading ? [1,2,3] : tagsArray}
                        description={videoData?.product_description ? videoData?.product_description : ''}
                        source={videoData.source ? videoData.source : ''}
                        type={'video'}
                        learnData={''}
                        isLoading={isLoading}
                        onLearnClick={()=>{}}
                    />
                </div>
                <div className="col-md-4 col-sm-12">
                    <RightPanelComponent 
                        parentName={"video"}
                        moduleData={videoData}
                        id={videoId}
                        code={videoCode}
                        type={'video'}
                        source={videoData.source ? videoData.source : ''}
                        isMobile={isMobile}
                    />
                </div>
            </div>
        </>
    )
}

export default VideoDetailComponent;